import React, { useState, useEffect } from "react";
import {
  Link,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";

// Core Imports
import { useAuth } from "../../contexts/AuthContext";
import ProtectedRoute from "../../components/ProtectedRoute";
import { ADMIN_AUTH, ROLES } from "../../config/authorizationConfig";

// Components
import Master from "./Master/Master";
import UserManagement from "../Admin/UserManagement";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

// Styles
import "../../styles/InnerMenu.scss";

const CompanyDetails = () => {
  const { isAuthorized, isLoading } = useAuth();
  const [visibleSubmenu, setVisibleSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // MENU ITEMS
  const menuItems = [
    {
      name: "Company Details",
      routes: ["/company-details/info"],
      auth: { roles: [ROLES.ADMIN, ROLES.HR] },
    },
    {
      name: "User Management",
      routes: ["/company-details/user-management"],
      auth: ADMIN_AUTH.USER_MANAGEMENT,
    },
  ];

  // Apply permission filtering
  const filteredMenuItems = menuItems.filter((item) => isAuthorized(item.auth));

  // Detect active tab
  useEffect(() => {
    const activeIndex = filteredMenuItems.findIndex((item) =>
      item.routes.some((route) => location.pathname.startsWith(route))
    );

    if (activeIndex !== -1) setVisibleSubmenu(activeIndex);
  }, [location.pathname, filteredMenuItems]);

  // When clicking a top menu item
  const handleMenuClick = (index) => {
    const item = filteredMenuItems[index];
    navigate(item.routes[0]);
    setVisibleSubmenu(index);
  };

  // Default redirect
  const getDefaultRedirect = () => {
    if (filteredMenuItems.length > 0) {
      return filteredMenuItems[0].routes[0];
    }
    return "/company-details/info";
  };

  if (isLoading) return <LoadingScreen />;

  return (
    <div className="custom-ess-container">
      {/* TOP MENU */}
      <div className="custom-menu">
        {filteredMenuItems.map((item, index) => {
          const isActive =
            visibleSubmenu === index ||
            item.routes.some((route) => location.pathname.startsWith(route));

          return (
            <div
              key={item.name}
              className={`custom-menu-item ${isActive ? "custom-active" : ""}`}
              onClick={() => handleMenuClick(index)}
            >
              <Link to={item.routes[0]} className="custom-menu-link">
                {item.name}
              </Link>
            </div>
          );
        })}
      </div>

      {/* MAIN CONTENT AREA */}
      <div className="custom-content">
        <Routes>
          {/* Company Details - renders Master with sidebar */}
          <Route
            path="info"
            element={
              <ProtectedRoute roles={[ROLES.ADMIN, ROLES.HR]}>
                <Master />
              </ProtectedRoute>
            }
          />

          {/* User Management */}
          <Route
            path="user-management"
            element={
              <ProtectedRoute {...ADMIN_AUTH.USER_MANAGEMENT}>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route
            path="/"
            element={<Navigate to={getDefaultRedirect()} replace />}
          />
        </Routes>
      </div>
    </div>
  );
};

export default CompanyDetails;
